var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import React from 'react';
import { action, observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

import { indexShowing } from 'sdc-cms-client';
import { editingMode } from 'sdc-cms-writing';

import { EntryDate, EntryTime, EntryLink, EntryChoices, FieldLabel, FieldEdit, ASINEdit } from '.';
import { MarkdownEdit, MarkdownView } from '../markdown';

import { Controls } from './controls';

export var ValueTextEdit = (_dec = inject('editingStore', 'typesStore'), _dec(_class = observer(_class = (_class2 = function (_React$Component) {
  _inherits(ValueTextEdit, _React$Component);

  function ValueTextEdit() {
    var _temp, _this, _ret;

    _classCallCheck(this, ValueTextEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initDefineProp(_this, 'error', _descriptor, _this), _initDefineProp(_this, 'info', _descriptor2, _this), _initDefineProp(_this, 'hasError', _descriptor3, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ValueTextEdit.prototype.componentDidCatch = function componentDidCatch(error, info) {
    this.hasError = true;
    this.error = error;
    this.info = info;
  };

  ValueTextEdit.prototype.render = function render() {
    var _props = this.props,
        typesStore = _props.typesStore,
        store = _props.editingStore,
        fieldName = _props.field,
        _props$locale = _props.locale,
        locale = _props$locale === undefined ? {} : _props$locale,
        _props$renderers = _props.renderers,
        renderers = _props$renderers === undefined ? {} : _props$renderers,
        _props$showLabels = _props.showLabels,
        showLabels = _props$showLabels === undefined ? true : _props$showLabels,
        _props$options = _props.options,
        options = _props$options === undefined ? {} : _props$options,
        props = _objectWithoutProperties(_props, ['typesStore', 'editingStore', 'field', 'locale', 'renderers', 'showLabels', 'options']);

    var field = typesStore.fields[fieldName] || {};
    if (!field.id) return null;
    var column = showLabels ? indexShowing.showing ? ' col-md-10' : ' col-md-9' : ' col';
    if (this.hasError) {
      return React.createElement(
        'div',
        { style: { color: 'red' } },
        React.createElement(
          'div',
          null,
          JSON.stringify(toJS(field))
        )
      );
    } else {
      var Custom = renderers[fieldName];
      return React.createElement(
        'div',
        { className: 'form-group row ' + editingMode.mode + 'ing' },
        showLabels && React.createElement(FieldLabel, _extends({ field: field, locale: locale }, props)),
        React.createElement(
          'div',
          { className: 'field-' + fieldName + column },
          Custom && React.createElement(Custom, _extends({ field: field, store: store }, props)),
          React.createElement(MarkdownView, _extends({ field: field }, props, { mdv: options.mdv || {} })),
          React.createElement(MarkdownEdit, _extends({ field: field, store: store, locale: locale }, props)),
          React.createElement(EntryChoices, _extends({ field: field, store: store }, props)),
          React.createElement(EntryDate, _extends({ field: field, store: store }, props)),
          React.createElement(EntryTime, _extends({ field: field, store: store }, props)),
          React.createElement(EntryLink, _extends({ field: field, store: store }, props)),
          React.createElement(FieldEdit, _extends({ field: field, locale: locale }, props)),
          React.createElement(ASINEdit, _extends({ field: field, locale: locale }, props)),
          React.createElement(Controls, _extends({ field: field, store: store, locale: locale }, props))
        )
      );
    }
  };

  return ValueTextEdit;
}(React.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'error', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'info', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'hasError', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'componentDidCatch', [action], Object.getOwnPropertyDescriptor(_class2.prototype, 'componentDidCatch'), _class2.prototype)), _class2)) || _class) || _class);